const productAccessories = document.querySelector(".js-product-accessories");
const whatsInTheBoxSection = document.querySelector(".section-whats-in-the-box");

function handleWhatsInTheBox() {
  const upsell = document.querySelector('input[id="upsell"]');
  const magicKeyboard = document.querySelector(".whats-in-the-box-block--magic_keyboard");
  const magic24Keyboard = document.querySelector(".whats-in-the-box-block--imac_24_inch_magic_keyboard");
  const magicNumericKeyboard = document.querySelector(".whats-in-the-box-block--magic_keyboard_with_numeric_keypad");

  if (upsell.checked) {
    if (magicKeyboard) magicKeyboard.style.display = "none";
    if (magic24Keyboard) magic24Keyboard.style.display = "none";
    if (magicNumericKeyboard) magicNumericKeyboard.style.display = "block";
  } else {
    if (magicKeyboard) magicKeyboard.style.display = "block";
    if (magic24Keyboard) magic24Keyboard.style.display = "block";
    if (magicNumericKeyboard) magicNumericKeyboard.style.display = "none";
  }
}

if (productAccessories && whatsInTheBoxSection) {
  handleWhatsInTheBox();
}

// Reload variants on accessory change (For price update)
window.addEventListener("DOMContentLoaded", () => {
  const selectedVariant = document.querySelector(".variant-input input[data-variant-input]:checked");
  if (selectedVariant) selectedVariant.dispatchEvent(new Event("change"));
});
